import React from 'react';

import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Button } from '@pkg/components/Sections/Profile/Buttons';

import { SortDropdown } from '../../../SortDropdown';

import { Actions, Filters, ModalContainer, ModalContent, ModalOverlay, SortDropdownWrapper, Top } from './styles';

const MODAL_CONTENT_ANIMATE_Y_DISTANCE = 20;

export interface FiltersListModalProps {
    open?: boolean;
    onClose(): void;
    onSubmit(): void;
    filterList: React.ReactNode;
    onClearFilters?: () => void;
}

export function FiltersListModal({
    open = false,
    onClose,
    onSubmit,
    filterList,
    onClearFilters,
}: FiltersListModalProps) {
    const { t: translate } = useTranslation(['yat_nft_manager', 'yat_page']);
    const theme = useTheme();

    return (
        <ModalOverlay
            className="v2-global-reset"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: theme.transitions.eases.cubic, duration: theme.transitions.speeds.fast }}
            data-state={open}
            // onOpenChange={onClose}
        >
            <ModalContent
                aria-label={translate('yat_page:nft_preview_modal_aria_label')}
                initial={{
                    opacity: 0,
                    y: MODAL_CONTENT_ANIMATE_Y_DISTANCE,
                }}
                animate={{
                    opacity: 1,
                    y: 0,
                }}
                exit={{ opacity: 0, y: MODAL_CONTENT_ANIMATE_Y_DISTANCE }}
                transition={{ ease: theme.transitions.eases.cubic, duration: theme.transitions.speeds.normal }}
            >
                <ModalContainer>
                    <Top>
                        <Button variant="solid" size="small" color="secondary" onClick={onClose}>
                            {translate('yat_nft_manager_close_filters_panel')}
                        </Button>
                    </Top>

                    <Filters>
                        <SortDropdownWrapper>
                            <SortDropdown />
                        </SortDropdownWrapper>
                        {filterList}
                    </Filters>

                    <Actions>
                        {onClearFilters && (
                            <Button fluid color="secondary" size="medium" onClick={onClearFilters}>
                                {translate('yat_nft_manager:yat_nft_manager_filter_clear_filters')}
                            </Button>
                        )}
                        <Button fluid size="medium" onClick={onSubmit}>
                            {translate('yat_nft_manager:yat_nft_manager_filter_apply')}
                        </Button>
                    </Actions>
                </ModalContainer>
            </ModalContent>
        </ModalOverlay>
    );
}
